import inboxIcon from '@iconify/icons-heroicons-solid/inbox';
import React from 'react';

import { PlaceholderView } from '../Base';

export interface EmptyViewProps {
  mainText: string;
  subText: string;
  containerClassName?: string;
  mainTextClassName?: string;
  subTextClassName?: string;
  iconContainerClassName?: string;
  iconClassName?: string;
}

export const EmptyView = ({
  mainText,
  subText,
  containerClassName,
  mainTextClassName,
  subTextClassName,
  iconContainerClassName,
  iconClassName,
}: EmptyViewProps) => {
  return (
    <PlaceholderView
      dataTestId="empty-view"
      icon={inboxIcon}
      mainText={mainText}
      subText={subText}
      containerClassName={containerClassName}
      mainTextClassName={mainTextClassName}
      subTextClassName={subTextClassName}
      iconContainerClassName={iconContainerClassName}
      iconClassName={iconClassName}
    />
  );
};
